import { Tooltip as AntdTooltip, TooltipProps } from "antd";
import classNames from "classnames";
import styles from "./index.module.css";

interface IProps extends Omit<TooltipProps, "disabled"> {
  theme: "light" | "vip";
  disabled?: boolean;
  rootClassNames?: string;
  bodyClassNames?: string;
}

export function Tooltip(props: IProps) {
  const { disabled, children, theme, rootClassNames, bodyClassNames, ...rest } =
    props;

  if (disabled) {
    return children;
  }

  const mergedClassNames = {
    root: classNames(
      styles.tooltipRoot,
      theme === "vip" && styles.tooltipVip,
      theme === "light" && styles.tooltipLight,
      rootClassNames
    ),
    body: classNames(bodyClassNames),
  };

  return (
    <AntdTooltip {...rest} classNames={mergedClassNames}>
      {children}
    </AntdTooltip>
  );
}
